import _DatabaseModel from "./_DatabaseModel";

class AppliedControl extends _DatabaseModel {
  static model = "applied_control";
}

export default AppliedControl;
